// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vxe-input--panel.type--date,\n.vxe-input--panel.type--month,\n.vxe-input--panel.type--week,\n.vxe-input--panel.type--year {\n  z-index: 9998 !important;\n}\n.vxe-select--panel {\n  z-index: 9997 !important;\n}\n", ""]);
// Exports
module.exports = exports;
